import { render, staticRenderFns } from "./ActivityRules.vue?vue&type=template&id=fd625866&scoped=true&"
import script from "./ActivityRules.vue?vue&type=script&lang=js&"
export * from "./ActivityRules.vue?vue&type=script&lang=js&"
import style0 from "./ActivityRules.vue?vue&type=style&index=0&id=fd625866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd625866",
  null
  
)

component.options.__file = "ActivityRules.vue"
export default component.exports